export const sortByPriority = (dealers) => {
    return dealers.sort((A, B) => {
        if (A.priority !== B.priority) {
            return A.priority - B.priority;
        }
        if (A.distance && B.distance && A.distance !== B.distance) {
            return A.distance - B.distance;
        }
        return A.name.localeCompare(B.name);
    })
}

export const sortByDistance = (dealers) => {
    return dealers.sort((A, B) => {
        if (A.distance && B.distance && A.distance !== B.distance) {
            return A.distance - B.distance;
        }

        return A.name.localeCompare(B.name);
    })
}

export const radi = [
    {
        title: '25',
        key: 25000
    },
    {
        title: '50',
        key: 50000
    },
    {
        title: '100',
        key: 100000
    },
    {
        title: '> 100',
        key: -1
    }
]

export const getInitialRadius = () => {
    if (radi.length) {
        if (radi.length > 1) {
            return radi[1]
        } else {
            return radi[0]
        }
    } else {
        return {
            title: '> 100',
            key: -1
        }
    }
}
